import { Dialog, Box, Typography, Button, useTheme, CircularProgress } from '@mui/material'
import { Icons } from '../../../shared/utils/icons.jsx'
import { getCroppedImage } from '../../../shared/utils/helpers.jsx'
import React, { useState } from 'react'
import ImageEditor from 'react-easy-crop'
import { toast } from 'react-toastify'
import { useUserStore } from '../../store/user.store'

const ProfileImageCropAndUploadDialog = ( { imageSrc, setImageSrc, setProfile } ) => {

    const [croppedAreaPixels, setCroppedAreaPixels] = useState( null )
    const [uploading, setUploading] = useState( false )
    const [crop, setCrop] = useState( { x: 0, y: 0 } )
    const [zoom, setZoom] = useState( 1 )

    const { palette } = useTheme()

    const UserStore = useUserStore()

    const onCropComplete = ( croppedArea, croppedAreaPixels ) => {
        setCroppedAreaPixels( croppedAreaPixels )
    }

    const handleClose = () => {
        setImageSrc( null )
    }

    const handleUpload = async () => {
        setUploading( true )
        const { file, url } = await getCroppedImage( imageSrc, croppedAreaPixels )
        const formData = new FormData()
        const fileObj = new File( [file], `${UserStore.getUser['user_id']}.jpeg`, { type: file.type } )

        const size = fileObj.size / 1024
        if ( size >= 1204 * 2 ) {
            return toast( 'Maximum file size limit exceeded (2MB)' )
        }

        const img = new Image()
        img.src = url
        img.addEventListener( 'load', ( e ) => {
            const { naturalWidth, naturalHeight } = e.currentTarget
            if ( naturalWidth < 200 || naturalHeight < 200 ) {
                toast( 'Minimum image size: 200*200' )
            }
        } )

        formData.append( 'profile', fileObj )

        if ( await UserStore.setUserProfileImg( formData ) ) {
            setProfile( url )
            setImageSrc( null )
        } else {
            toast( "Something went wrong while updating your profile image!" )
        }
        setUploading( false )
    }

    return (
        <Dialog onClose={handleClose} open={Boolean( imageSrc )} slotProps={{
            paper: { sx: { width: "80%", maxWidth: "400px" } }
        }}>
            <Box
                sx={{
                    borderBottom: "1px solid #d3d3d3",
                    padding: "20px"
                }}>
                <Typography variant="subtitle2">Adjust your profile image</Typography>
                <Typography variant="body2" color="textSecondary" sx={{
                    fontSize: "12px"
                }}>Max Size: 2MB, Minimum dimentions: 200px * 200px</Typography>
            </Box>
            {imageSrc && <Box
                sx={{
                    display: "flex",
                    justifyContent: "center"
                }}>
                <Box
                    sx={{
                        width: "300px",
                        height: "300px",
                        position: "relative"
                    }}>
                    <ImageEditor
                        style={{ containerStyle: { background: "none" } }}
                        objectFit='contain'
                        image={imageSrc}
                        showGrid={false}
                        cropShape='round'
                        crop={crop}
                        zoom={zoom}
                        aspect={1}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={onCropComplete}
                    />
                </Box>
            </Box>}
            <Box
                sx={{
                    bgcolor: palette.contentBg,
                    display: "flex",
                    gap: "20px",
                    justifyContent: "flex-end",
                    borderTop: "1px solid #d3d3d3",
                    padding: "20px"
                }}>
                <Button sx={{ textTransform: "capitalize" }} startIcon={uploading ? <CircularProgress size={14} /> : Icons.default.UploadFileIcon} onClick={handleUpload} variant="contained" disabled={uploading} disableElevation>{uploading ? "Uploading..." : "Upload"}</Button>
                <Button sx={{ textTransform: "capitalize" }} color="error" onClick={handleClose} variant="contained" disabled={uploading} disableElevation>Cancel</Button>
            </Box>
        </Dialog>
    );
}

export default ProfileImageCropAndUploadDialog
